export function Logo({ size = 28, withText = true, light = false }) {
  // `size` historically referred to the mark height; the brand image is a
  // stacked mark + wordmark, so render it a touch larger for legibility.
  const height = Math.round(size * (withText ? 2.5 : 1.5) * 1.25);
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/orgaviya-logo.png`}
      alt="Orgaviya Foods"
      data-testid="brand-logo"
      style={{ height, width: "auto" }}
      className="object-contain select-none"
      draggable={false}
    />
  );
}
